import React, { useEffect, useState } from "react";
import { TextField } from "@mui/material";
import styles from "./input.module.css";

const MsdTextBoxInput = (props) => {
	const {
		question,
		field,
		hasError,
		errorMessage,
		hasOthersError,
		onOtherTextChange,
		optionId,
		// onLogicChange,
		index,
		hasPhoneError1,
		hasPhoneError2,
	} = props;

	const numberValidationIds = process.env.REACT_APP_MSD_TF_NUMBER_IDS;
	const emailValidationIds = process.env.REACT_APP_MSD_TF_EMAIL_IDS;
	const phoneNumberIds = process.env.REACT_APP_MSD_PHONE_NUMBER_IDS;
	const phoneNumberIdOne = process.env.REACT_APP_PHONE_NUMBER_ID_ONE;
	const phoneNumberIdTwo = process.env.REACT_APP_PHONE_NUMBER_ID_TWO;

	const isPhoneOneError = field?.name === phoneNumberIdOne;
	const isPhoneTwoError = field?.name === phoneNumberIdTwo;

	const shouldValidateNumber = numberValidationIds
		?.split(",")
		.includes(field?.name);

	const isPhoneNumber = phoneNumberIds?.split(",").includes(field?.name);
	const isEmail = emailValidationIds?.split(",").includes(field?.name);

	const [text, setText] = useState(field?.value || "");
	const [error, setError] = useState({
		show: false,
		message: "",
	});

	const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

	const handleValidationError = (message) => {
		setError({ show: true, message });
		hasOthersError(true);
	};

	const clearValidationError = () => {
		setError({ show: false, message: "" });
		hasOthersError(false);
	};

	const handleChange = (e) => {
		const value = e.target.value;

		// Required validation
		if (value.trim() === "") {
			handleValidationError("value is required");
			setText("");
			return;
		}

		// Email validation
		if (isEmail) {
			if (!emailRegex.test(value)) {
				handleValidationError("Invalid email address");
			} else {
				clearValidationError();
			}
		}

		// Number-only validation
		else if (shouldValidateNumber) {
			if (/\D/.test(value)) {
				return handleValidationError("Only numbers are allowed");
			}

			// Phone number validation
			if (isPhoneNumber) {
				if (value.length > 11) {
					return handleValidationError(
						"Phone number cannot exceed 11 digits"
					);
				}

				if (value.length === 11) {
					clearValidationError();
				}
			} else {
				clearValidationError();
			}
		}

		// Letters-only validation
		else {
			if (/[^A-Za-z\s]/.test(value)) {
				return handleValidationError("Only letters are allowed");
			}

			clearValidationError();
		}

		// Set value and notify parent
		setText(value);
		field?.onChange?.(e);

		onOtherTextChange({
			id: optionId,
			text: value.trim() === "" ? "NULL" : value,
			type: "TEXT-BOX",
		});
	};

	useEffect(() => {
		if (text?.trim() === "") {
			setError({
				show: true,
				message: "value is required",
			});
			hasOthersError(true);
		}

		if (isPhoneNumber && text.length !== 11) {
			if (isPhoneOneError) {
				console.log("setting phone one error to true");
				hasPhoneError1(true);
			}
			if (isPhoneTwoError) {
				console.log("setting phone two error to true");
				hasPhoneError2(true);
			}
			setError({
				show: true,
				message: "Phone number should be 11 digits",
			});

			hasOthersError(true);
		}
		if (isPhoneNumber && isPhoneOneError && text.length !== 11) {
			hasPhoneError1(true);
			setError({
				show: true,
				message: "Phone number should be 11 digits",
			});

			hasOthersError(true);
		}

		if (isPhoneNumber && isPhoneTwoError && text.length !== 11) {
			hasPhoneError2(true);
			setError({
				show: true,
				message: "Phone number should be 11 digits",
			});

			hasOthersError(true);
		}

		if (isPhoneNumber && isPhoneTwoError && text.length === 11) {
			hasPhoneError2(false);
			setError({
				show: false,
				message: "",
			});

			hasOthersError(false);
		}

		if (isPhoneNumber && isPhoneOneError && text.length === 11) {
			hasPhoneError1(false);
			setError({
				show: false,
				message: "",
			});

			hasOthersError(false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [text]);

	return (
		<div
			className={styles.dropdown_wrapper}
			data-testid="textbox_input_container"
		>
			<div className="flex mb-1 gap-2">
				<span className="text-center bg-primary text-white py-[2px] px-1 rounded-sm !text-sm mr-2 block h-6">
					{index + 1}
				</span>
				<p>{question}</p>
			</div>

			<TextField
				{...field}
				id="mainText"
				label="Enter your response"
				variant="outlined"
				size="small"
				className="w-full"
				value={text}
				onChange={handleChange}
				data-testid="textbox_input"
			/>

			{(hasError || error.show) && (
				<small
					className="text-danger mt-1"
					data-testid="textbox_error_element"
				>
					{errorMessage || error.message}
				</small>
			)}
		</div>
	);
};

export default MsdTextBoxInput;
